<div class="ha-health-goals-section section-wrapper">
	<div id="lifestyle-health-goals">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.health-goals.heading'">Health Goals</span>
		</div>
		<div [formGroup]="healthGoalsForm">
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.lifestyle.health-goals.form-fields.goals'">
				What are your health and wellness goals?
			</div>
			<div class="checkbox-list" *ngFor="let condition of healthGoalsOptions">
				<mat-checkbox
					appAutofocus
					[disabled]="readOnly"
					appAutofocus
					(change)="healthGoalsSelection(condition)"
					[checked]="condition.checked"
					>{{ condition.name }}</mat-checkbox
				>

				<mat-form-field class="text-field" appearance="fill" *ngIf="condition.name === 'Other' && condition.checked">
					<mat-label
						><span
							[translate]="'wellness.health-assessment-new.lifestyle.health-goals.form-fields.otherGoalDescription'"
							>My goals</span
						></mat-label
					>
					<textarea
						matInput
						cdkTextareaAutosize
						cdkAutosizeMinRows="1"
						cdkAutosizeMaxRows="4"
						formControlName="otherGoalDescription"></textarea>
				</mat-form-field>
			</div>

			<div class="form-field">
				<div class="radio-btn-label">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.lifestyle.health-goals.form-fields.healthMindedLifestyleImportance'
							"
							>How important is it for you to make health-minded lifestyle changes?</span
						></mat-label
					>
				</div>
				<div class="slider">
					<div class="slider-labels">
						<span class="label-left">Not Important</span>
						<span class="label-right">Very Important</span>
					</div>
					<mat-slider [disabled]="readOnly" [max]="max" [min]="min" [step]="step" [showTickMarks]="true">
						<input
							matSliderThumb
							formControlName="healthMindedLifestyleImportance"
							[(ngModel)]="healthGoalsData.healthMindedLifestyleImportance" />
					</mat-slider>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
